module.exports = __webpack_public_path__ + "static/media/loader.79deed63.gif";